export default __webpack_public_path__ + "static/sc-state-7bee30646a07d014164c58b2de5dd850.webp";